/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/jsx-props-no-spreading */

const PictureComponent = (props) => {
    const {
        srcSet, src, outerClass, imgClass,
    } = props;
    return (
        <picture className={outerClass}>
            {srcSet && <source srcSet={srcSet} type="image/webp" {...props} />}
            <img src={src || srcSet} className={imgClass} {...props} alt={props?.title} />
        </picture>
    );
};

PictureComponent.defaultProps = {
    alt: '',
    height: '100%',
    width: '100%',
    onLoad: () => { },
};

PictureComponent.propTypes = {
    srcSet: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
    alt: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    outerClass: PropTypes.string.isRequired,
    imgClass: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default React.memo(PictureComponent);
